export const redactLinks = (msg: string) =>
  msg?.replace(/(?:https?|ftp):\/\/[\n\S]+/g, "*** LINK REDACTED ***");
